// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2MnQ4","tab":"Tabs_tab__24PAv","tabActive":"Tabs_tabActive__11iDC"};